import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container } from "../Layouts";
import { motion } from "framer-motion";
import { css, keyframes } from "styled-components/macro";
import React_logo from "../../../Images/React_logo.png";
import Redux_logo from "../../../Images/Redux_logo.png";
import JS_logo from "../../../Images/JS_logo.png";
import dotNetCore_logo from "../../../Images/dotNetCore_logo.png";
import cSharp_logo from "../../../Images/cSharp_logo.png";
import sqlServer_logo from "../../../Images/sqlServer_logo.png";
import aws_logo from "../../../Images/aws_logo.png";
import gcp_logo from "../../../Images/gcp_logo.png";
import azure_logo from "../../../Images/azure_logo.png";
import bootstrap_logo from "../../../Images/bootstrap_logo.png";
import tailwind_logo from "../../../Images/tailwind_logo.png";
import css_logo from "../../../Images/css_logo.png";
import html_logo from "../../../Images/html_logo.jpg";
import nodejs_logo from "../../../Images/nodejs_logo.png";
import mvc_logo from "../../../Images/mvc_logo.png";
import vbDotNet_logo from "../../../Images/vbDotNet_logo.png";
import aspDotNet_logo from "../../../Images/aspDotNet_logo.png";
import ajax_logo from "../../../Images/ajax_logo.png";
import webApi_logo from "../../../Images/webApi_logo.png";
import jwt_logo from "../../../Images/jwt.svg";
import mysql_logo from "../../../Images/Mysql_logo.png";
import jira_logo from "../../../Images/jira_logo.png";
import slack from "../../../Images/slack.png";
import github from "../../../Images/github.png";
import docker from "../../../Images/docker.png";
import kubernetes from "../../../Images/kubernetes.png";

const TechStack1 = () => {
  const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto pb-6 pt-10`;
  const HeaderRow = tw.div`flex  justify-center items-center flex-col xl:flex-row`;
  //   const Header = tw(SectionHeading)``;
  const TabsControl = tw.div`flex  flex-wrap bg-gray-200 px-2 py-2 rounded leading-none mt-12 xl:mt-0`;
  const TabControl = styled.div`
    ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
    &:hover {
      ${tw`bg-gray-300 text-gray-700`}
    }
    ${(props) => props.active && tw`bg-primary-500 text-gray-100`}
  `;
  const TabContent = tw(
    motion.div
  )`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
  const CardContainer = tw.div`mt-5 sm:w-1/4 md:w-1/4 lg:w-40 sm:pr-10 md:pr-6 lg:pr-10 `;
  const Card = tw.div`mb-8 flex flex-wrap justify-around md:w-full mx-8 lg:w-full xl:w-full border-2`;
  const growAnimation = keyframes`
  0% {
    transform: scale(0);
  }
 
  100% {
    transform: scale(1);
  }
`;

  const CardImageContainer = styled.div`
    ${(props) =>
      css`
        background: url("${props.imageSrc}");
      `}
    ${tw`m-2 h-18 w-18 bg-center bg-cover relative rounded-lg`}
    animation: ${growAnimation} 1s ease-in-out;
    transform-origin: center;
  `;

  const CardText = tw.div`p-2 text-gray-900`;
  const CardTitle = tw.h5`text-center text-sm font-semibold group-hover:text-primary-500 `;

  const tabs = {
    Frontend: [
      {
        imageSrc: React_logo,
        title: "React",
      },
      {
        imageSrc: Redux_logo,
        title: "Redux",
      },
      {
        imageSrc: JS_logo,
        title: "Javascript",
      },
      {
        imageSrc: bootstrap_logo,
        title: "Bootstrap",
      },
      {
        imageSrc: tailwind_logo,
        title: "Tailwind CSS",
      },
      {
        imageSrc: css_logo,
        title: "CSS",
      },
      {
        imageSrc: html_logo,
        title: "HTML",
      },
    ],
    Backend: [
      {
        imageSrc: dotNetCore_logo,
        title: ".Net Core",
      },
      {
        imageSrc: cSharp_logo,
        title: "C Sharp",
      },
      {
        imageSrc: webApi_logo,
        title: "Web API",
      },
      {
        imageSrc: mvc_logo,
        title: "MVC",
      },
      {
        imageSrc: aspDotNet_logo,
        title: "ASP.Net",
      },
      {
        imageSrc: vbDotNet_logo,
        title: "VB.Net",
      },
    ],
    Servers: [
      {
        imageSrc: sqlServer_logo,
        title: "SQL Server",
      },
      {
        imageSrc: nodejs_logo,
        title: "Node.js",
      },
      {
        imageSrc: ajax_logo,
        title: "AJAX",
      },
      {
        imageSrc: jwt_logo,
        title: "JWT",
      },
      {
        imageSrc: mysql_logo,
        title: "MySQL",
      },
    ],
    Cloud: [
      {
        imageSrc: aws_logo,
        title: "Amazon Web Services",
      },
      {
        imageSrc: azure_logo,
        title: "Microsoft Azure Cloud",
      },
      {
        imageSrc: gcp_logo,
        title: "Google Cloud Platform",
      },
    ],
    DevOps: [
      {
        imageSrc: github,
        title: "GitHub",
      },
      {
        imageSrc: slack,
        title: "Slack",
      },
      {
        imageSrc: jira_logo,
        title: "Jira",
      },
      {
        imageSrc: docker,
        title: "Docker",
      },
      {
        imageSrc: kubernetes,
        title: "Kubernetes",
      },
    ],
  };

  const tabsKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <TabsControl>
            {Object.keys(tabs).map((tabName, index) => (
              <TabControl
                key={index}
                active={activeTab === tabName}
                onClick={() => setActiveTab(tabName)}
              >
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>
        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale: 1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale: 0.8,
                display: "none",
              },
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            <Card>
              {tabs.Frontend.map(
                (card, index) =>
                  tabKey === "Frontend" && (
                    <CardContainer key={index}>
                      <CardImageContainer imageSrc={card.imageSrc} />
                      <CardText>
                        <CardTitle>{card.title}</CardTitle>
                      </CardText>
                    </CardContainer>
                  )
              )}
              {tabs.Backend.map(
                (card, index) =>
                  tabKey === "Backend" && (
                    <CardContainer key={index}>
                      <CardImageContainer
                        imageSrc={card.imageSrc}
                      ></CardImageContainer>
                      <CardText>
                        <CardTitle>{card.title}</CardTitle>
                      </CardText>
                    </CardContainer>
                  )
              )}
              {tabs.Servers.map(
                (card, index) =>
                  tabKey === "Servers" && (
                    <CardContainer key={index}>
                      <CardImageContainer
                        imageSrc={card.imageSrc}
                      ></CardImageContainer>
                      <CardText>
                        <CardTitle>{card.title}</CardTitle>
                      </CardText>
                    </CardContainer>
                  )
              )}
              {tabs.Cloud.map(
                (card, index) =>
                  tabKey === "Cloud" && (
                    <CardContainer key={index}>
                      <CardImageContainer
                        imageSrc={card.imageSrc}
                      ></CardImageContainer>
                      <CardText>
                        <CardTitle>{card.title}</CardTitle>
                      </CardText>
                    </CardContainer>
                  )
              )}
              {tabs.DevOps.map(
                (card, index) =>
                  tabKey === "DevOps" && (
                    <CardContainer key={index}>
                      <CardImageContainer
                        imageSrc={card.imageSrc}
                      ></CardImageContainer>
                      <CardText>
                        <CardTitle>{card.title}</CardTitle>
                      </CardText>
                    </CardContainer>
                  )
              )}
            </Card>
          </TabContent>
        ))}
      </ContentWithPaddingXl>
    </Container>
  );
};

export default TechStack1;
